
export class LoadBankApplyLoads {
    loadIds: number[] = [];
    loadBankIds: number[] = [];
}